import { createAsyncThunk } from "@reduxjs/toolkit";
import { CUR8_SERVER } from "gatsby-env-variables";
import axios from "axios";
import { logException } from "@helpers/logException/logException";
import { DealsFundraisingCapacity } from "./dealCapacity.types";

const FETCH_DEALS_FUNDRAISING_CAPACITY_API =
  "FETCH_DEALS_FUNDRAISING_CAPACITY_API";

// Batched capacity fetch via direct axios (installed SDK type omits windowStart).
export const fetchDealsFundraisingCapacityThunk = createAsyncThunk<
  DealsFundraisingCapacity,
  string[]
>(
  FETCH_DEALS_FUNDRAISING_CAPACITY_API,
  async (dealIds, { rejectWithValue }) => {
    if (!dealIds.length) {
      return {};
    }

    try {
      const response = await axios.get<DealsFundraisingCapacity>(
        `${CUR8_SERVER}/deals/fundraising-capacity`,
        {
          params: { dealIds: dealIds.join(",") },
          withCredentials: true,
        }
      );
      return response.data ?? {};
    } catch (e: unknown) {
      const error = e as { response?: { status?: number }; message?: string };
      if (error.response?.status !== 401) {
        logException({
          tag: "fetchDealsFundraisingCapacityThunk",
          exception: e,
        });
      }
      return rejectWithValue(error.message);
    }
  }
);
